// extracted by mini-css-extract-plugin
export default {"fr-view":"GAR_fr-view__ODIj1","checkboxes":"GAR_checkboxes__GMoMx","checkbox":"GAR_checkbox__cbcrP"};